var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.getIcon(_vm.level))}})
}
var staticRenderFns = []

export { render, staticRenderFns }